<template>
    <form-row title="Has the inspection been waived">
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center justify-between">
            <input-radio-boolean
                name="inspection_is_waived"
                v-model="inspection_is_waived"
                true="Yes"
                false="No"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        attorney: {},
        read_only: { default: false },
    },

    data() {
        return {
            inspection_is_waived: this.attorney.inspection_is_waived,
        }
    },

    watch: {
        inspection_is_waived(val, oldVal) {
            this.$emit('updated', val);
        },
    },
}
</script>
